module.exports = __webpack_public_path__ + "static/media/open_api.ff841106.md";